var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-403"},[_c('ErrorPage',{attrs:{"code":'',"desc":"抱歉，该页面暂时没有权限，请联系系统管理员"}},[_c('img',{attrs:{"slot":"img","src":require("../assets/image/403.svg"),"alt":""},slot:"img"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }